import { GoldenModal } from '@ui/components/GoldenModal/GoldenModal';

export function GameCancelledModal() {
  return (
    <GoldenModal>
      <h1>Партия отменена</h1>
    </GoldenModal>
  );
}
